









































import { Component, Prop } from "vue-property-decorator";
import { ItemKit, Produto, ProdutosService } from "@/services/produtos.service";
import AdicionarItemKit from "./AdicionarItemKit.vue";
import { moeda } from "@/shared/filters";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";

@Component({
  components: {
    AdicionarItemKit,
    Tooltip,
    Confirm,
  },
  filters: { moeda },
})
export default class TabelaItemKit extends mixins(GlobalMixin) {
  @Prop() produto!: Produto;
  @Prop() idCatalogo!: string;

  headers = [
    { value: "descricao", text: "Produto" },
    { value: "valorVenda", text: "Valor Venda" },
    { value: "quantidade", text: "Quantidade" },
    { value: "acoes", text: "Ações" },
  ];

  async adicionarItemKit() {
    const modal = this.$refs.adicionarItemKit as AdicionarItemKit;
    if (this.produto.idProduto && this.idCatalogo) {
      await modal.novoItem(this.produto.idProduto, this.idCatalogo);
    }
  }

  adicionarProduto() {
    this.$emit("alteracao-items");
  }
  async excluirItem(item: ItemKit) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir item do kit ${item.produto.descricao}`;
    const text = `Deseja realmente deletar o item ${item.produto.descricao} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await ProdutosService.removerItemKit(item.idItemKit).finally(
        this.stopLoader
      );
      this.$emit("alteracao-items");
    }
  }
}
